import { createRoot } from "react-dom/client";
import { Provider } from "react-redux";
import App from "./App";
import store from "./redux/store";
import "./styles/app.css";

// Only runs in development where module.hot is available
if (module.hot) {
  module.hot.accept();
}

const root = createRoot(document.getElementById("app")!);
root.render(
  <Provider store={store}>
    <App />
  </Provider>
);

